// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"457436c8","111":"2aacd650","378":"fe9bf18f","537":"29a40cfb","692":"2437dc7f","765":"8a66b44a","816":"2ba10dfd","818":"4a35fe77"}[chunkId] + ".chunk.js";
};